<template>
  <div class="SocialPage">
      <div class="container">
        <div class="row text-right" dir="rtl">
          <h1 class="mt-2">شبکه‌های اجتماعی نوراشاپ</h1>
          <div class="filters">
            <ul class="bread-crumb">
              <li class="bread-crumb-item"><router-link to="/">نوراشاپ</router-link> / </li>
              <li class="bread-crumb-item"><router-link to="/social">شبکه‌های اجتماعی</router-link></li>
            </ul>
          </div>
        </div>
        <hr>
        <PageContent mode="SocialPage" />
      </div>
  </div>
</template>
<script>
import PageContent from '@/components/PageContent.vue'

export default {
  name: 'SocialPage',
  components: {
    PageContent
  },
  beforeMount () {
    const query = `
    {
      meta(key:"${this.$options.name}") {
        seoTitle
        seoKeyword
        seoDescription
      }
    }
    `
    this.$fetchGraphQL(query).then(res => {
      this.setMetaByObj(res.data.meta)
    })
  }
}
</script>

<style scoped>
.filters{
  background: #f2f2f2;
  padding: 8px 15px;
  border-radius: 3px;
  clip-path: polygon(25px 0%, 100% 0%, 100% 50%, 100% 100%, 0% 100%, 0% 25px);
}
</style>
